import BsPerson from '@meronex/icons/bs/BsPerson';
import icon from './StyledIcon';
export default icon(BsPerson, {strokeWidth: '.3px'});
